import { AssetNodeCategoryType, AssetNodeType } from '@festo-ax/smartenance-shared-ui';

export type { AssetTreeDto } from '@shared-types/assets/asset-tree-dto';

export enum ActionTypeEnum {
  CREATE = 'Create',
  UPDATE = 'Update',
  MOVE = 'Move',
}

export interface AssetSelected {
  nodeId: string;
  assetId: string|null;
}

export interface AssetGroupCreateOptions {
  nodeDescription: string;
  parentNodeId?: string;
}

export interface AssetGroupUpdateOptions {
  nodeDescription: string;
  nodeId: string;
}

export interface AssetMachinesCreateOptions {
  assetsIds: string[];
  parentNodeId?: string;
}

export interface AssetChildrenInformation {
  nodeCategory: AssetNodeCategoryType;
  nodeDescription?: string;
  assetId?: string;
}

export interface CreateAssetBody {
  actionType: ActionTypeEnum.CREATE;
  children: AssetChildrenInformation[];
  parentNodeId?: string;
  leftSiblingNodeId?: string;
  rightSiblingNodeId?: string;
}

export interface UpdateAssetBody {
  actionType: ActionTypeEnum.UPDATE;
  nodeId: string;
  nodeDescription?: string;
}

export interface AssetTreeApiParams {
  nodeId?: string;
  depthLevel?: number;
}

export interface AssetTreeStorage {
  assetTreeView: AssetTreeVM[];
  rootNodeId: string;
  selected: AssetSelected;
}

export interface AssetTreeShortDto {
  nodeId: string;
  assetId: string;
  nodeDescription: string;
  nodeType: AssetNodeType;
}

export interface SapAssetTreeShortVM {
  nodeId: string;
  nodeName: string;
  nodeType: AssetNodeType;
  isInactive: boolean;
  disabled?: boolean;
}

export interface AssetTreeShortVM {
  nodeId: string;
  assetId: string;
  nodeName: string;
  nodeType: AssetNodeType;
}

export interface AssetTreeVM {
  nodeId: string;
  nodeName: string;
  nodeType: AssetNodeType;
  nodeCategory: AssetNodeCategoryType,
  ariaLevelDepth: number;
  ariaExpanded: boolean;
  hasChildren: boolean;
  parentNodeId: string | null;
  assetId: string | null;
  showWarning: boolean;
  showLoading: boolean;
  hided: boolean;
  childrenNotLoaded: boolean;
  disabled: boolean;
}
